var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m97.101326 17.3363228c-29.4292908 23.1715202-46.4923515 38.3682518-64.3947792 66.6807899-.3584595.5668945-1.1582546.649025-1.6132622.1562424l-28.322371-30.6736069c-.392673-.4252701-.3537087-1.091568.0858567-1.468174l15.4408789-13.2291718c.464323-.3978157 1.1718044-.3011627 1.5124054.2066193l11.0771656 16.5142365c29.3021757-25.7894592 54.6767523-36.3566399 65.2591574-39.9605532 1.0894241-.3710107 1.859169 1.0616656.9549484 1.7736178z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bebd7046f835452f2d5c86b6534dd612.svg";
export { ForwardRef as ReactComponent };